/*

	todo:
		-adjust sprite scale when anti-aliasing not supported (figure out check)
		-
		-resizing for scatter?
		-usa "hop" into 5-up
		-inconsistent alignment on scatter
		-GRI/SHI highlighting not working on Safari
		-when scrolling quickly, getting stuck on static caption slides
		-mobile landscape
		-switching between desktop and mobile

	issues:
		- on my (old) laptop WebGL memory leak under Chrome 73, seems fine on iMac and elsewhere
		- Safari iMac canvas flicker on screen resize
		-IE on ThinkPad has problems with openGL?

	nice:
		- performance improvements for integrated fillrate https://github.com/pixijs/pixi.js/issues/5246
		- try to get info about graphics card and maybe disable retina if only integrated is available
		- culling branch https://github.com/pixijs/pixi.js/issues/351
		-culling - http://www.html5gamedevs.com/topic/31540-how-to-cull-objects-out-of-camera-view/
		** culling seems to only work when they are not particles https://github.com/pixijs/pixi.js/issues/3854
		-Crossfilter?
		-d3 zooming https://bl.ocks.org/pkerpedjiev/cf791db09ebcabaec0669362f4df1776
		- maybe turn force off when not in use
		- make svg overlay responsive
		- color interpolation
		- more mobile refinements needed - scatterplot in particular
		- compress JSON - decompress client side
*/



/* PIXI settings */
import * as PIXI from 'pixi.js';

//PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
//PIXI.settings.SPRITE_MAX_TEXTURES = 1;
//PIXI.settings.SPRITE_BATCH_SIZE = 1024;
//PIXI.glCore.VertexArrayObject.FORCE_NATIVE = true;
//PIXI.settings.PRECISION_FRAGMENT = PIXI.PRECISION.LOW;
//PIXI.settings.MIPMAP_TEXTURES = false;
//PIXI.settings.PREFER_ENV = PIXI.ENV.WEBGL; v5
//PIXI.settings.TARGET_FPMS = 0.03;

/* App settings */
export
	const
			COUNTRY_INFO_DEFAULT = ``,
			DEBUG = false,
			MOBILE_DEVICE = new RegExp('(ipad|ipod|iphone|android)','g').test(navigator.userAgent.toLowerCase()) || navigator.maxTouchPoints > 0,
			POPULATION = 7 * Math.pow(10, 9),
			WIDTH = window.innerWidth,
			HEIGHT = window.innerHeight,
			NO_ALIAS = false,
			MOBILE_WIDTH = 741,
			MID_WIDTH = 1440,
			MAX_WIDTH = 1920,
			FORCE_CANVAS = false,
			FIREBASE_REF = 'restrictions-essay-2024',
			ASSETS = 'https://assets.pewresearch.org/interactives/religion/2019/restrictions/',
			GRI_BREAKS = [2.301, 4.401, 6.501],
			SHI_BREAKS = [1.401, 3.501, 7.101],
			INDEX_LABELS = ['Low', 'Moderate', 'High', 'Very high'],
			MIN_YEAR = 2007,
			MAX_YEAR = 2023,
			DEFAULT_COLOR = 0xC9DEEE,
			HIGHLIGHT_COLOR = 0x71B2D6,
			LIGHT_GRAY = 0xefefef,
			DARK_GRAY = 0xcccccc,
			WHITE = 0xffffff,
			REGIONS = {
				'Americas' : 0x949D49,
				'Asia-Pacific' : 0x0091C1,
				'Europe' : 0x756A7E,
				'Middle East-North Africa' : 0xD2A830,
				'Sub-Saharan Africa': 0xC03B28
			},
			ASPECT_RATIO = WIDTH < MOBILE_WIDTH || WIDTH/HEIGHT < 1 ? [1,1] : WIDTH/HEIGHT > 1.8 ? [2.1, 1] : [16,9],
			MAX_SIZE = Math.min(WIDTH, MAX_WIDTH),
			MAX_GRID_SIZE = MAX_SIZE/2 - MAX_SIZE/8,
			OFFSCREEN_X = 0,
			OFFSCREEN_Y = -45,
			COLOR_MATRIX = [
				[0xE9E6CD, 0xE9DDBF, 0xf4dbbd, 0xf5c6ac],
				[0xE9DDBF, 0xf4dbbd, 0xf5c6ac, 0xf2b0a2],
				[0xf4dbbd, 0xf5c6ac, 0xf2ad9e, 0xe89389],
				[0xf5c6b6, 0xf2b0a2, 0xe89389, 0xd48379]
			],
			DEFINITE_ARTICLE =  [
				'044',
				'140',
				'174',
				'203',
				'214',
				'270',
				'384',
				'462',
				'584',
				'528',
				'608',
				'090',
				'784',
				'826',
				'840'
			],
			UNMAPPED = [
				'020',
				'028',
				'212',
				'583',
				'308',
				'296',
				'438',
				'584',
				'492',
				'520',
				'585',
				'882',
				'674',
				'678',
				'690',
				'659',
				'662',
				'670',
				'776',
				'798'
			],
 			ORDER = [	null, null, "643", null, null,
									null, null, "050", null, null,
									null, null, "276", null, null,
									null, null, "380", null, null,
									null, null, "764", null, null
			],
			SPRITE_SCALE = NO_ALIAS ? 1 : 1.02,
			BLACKLIST_SPRITE_SCALE = .75,
			// animation time
			// scatterplot delay time
			DPR = FORCE_CANVAS ? 1 : window.devicePixelRatio || 1,
			RENDER_OPTIONS = {
				antialias: !NO_ALIAS,
				transparent: true,
				//forceFXAA: true,
				// legacy: true,
				// backgroundColor: 0xffffff,
				//roundPixels: true,
				forceCanvas: FORCE_CANVAS,
				resolution: DPR,
				autoResize: true,
				autoStart: false, // dont call render automatically
				sharedTicker:false, // use our own ticker
				//powerPreference: "high-performance",  // causes Safari High Sierra to crash!!!??
			};
